import { useCallback } from 'react';
import { GrowthRateBasisType, Nullable } from '@xplan-pension-switching/common';
import { atLeastOneGreaterThanZero } from '../../helpers';
import { getSuffixFromGrowthRateBasisType } from '../../helpers/GetSuffixFromGrowthRateBasisType/GetSuffixFromGrowthRateBasisType';

export const useAtLeastOneGreaterThanZero = (
    growthRateBasisType: GrowthRateBasisType
): {
    atLeastOneGrowthRateGreaterThanZero: (formValues: {
        projectedGrowthRates: { [key: string]: string };
    }) => Nullable<boolean>;
} => {
    const suffix = getSuffixFromGrowthRateBasisType(growthRateBasisType);
    const atLeastOneGrowthRateGreaterThanZero = useCallback(
        (formValues: { projectedGrowthRates: { [key: string]: string } }) => {
            const values = (
                [
                    formValues.projectedGrowthRates[`growthRateLow${suffix}`],
                    formValues.projectedGrowthRates[`growthRateMid${suffix}`],
                    formValues.projectedGrowthRates[`growthRateHigh${suffix}`],
                ] as string[]
            ).map(Number);
            return atLeastOneGreaterThanZero(values);
        },
        [suffix]
    );

    return { atLeastOneGrowthRateGreaterThanZero };
};
